import React from 'react';
import CopyrightIcon from '@material-ui/icons/Copyright';
import {Styles} from './Styles';

const Guide = ()=> {
    const classes = Styles.base();
	return (
		<div id="guide" className={classes.mainRoot} style={{overflow:"auto"}}>
            <div style={{padding:"1em"}}>
                <ol style={{paddingLeft:"1em",lineHeight:"2em"}}>
                    <li>これはレトロインクが作りました。</li>
                    <li>これは突然無くなってしまう場合があります。</li>
                    <li>これは突然リセットされてしまう場合もあります。</li>
                    <li>これで作ったテキストの著作権はレトロインクが有します。</li>
                    <li>万が一のトラブルが嫌なので書きましたが基本的にはうるさいことは言わないです。</li>
                </ol>
                <div style={{margin:"5em 0em",textAlign:"center"}}>
                    ガンネンタンカ！<br/>
                    ver.20190704<br/>
                    <br/>
                    <span className={classes.withIcon} ><CopyrightIcon/>レトロインク　2019</span><br/>
                    <a href="https://goisagi.retro-ink.com/" target="_blank" className="tw" rel="noopener noreferrer" style={{textDecoration:"none"}}>https://goisagi.retro-ink.com/</a>
                </div>
            </div>
    	</div>
	);
}

export default Guide;
